import type { AdminInvitation } from "@/shared/invitations/types";

/**
 * True when an invitation row does not belong to this organization (it names
 * another one, or none): the API ignored the `organizationId` filter, so the
 * page would show other organizations' invitee emails under this one.
 */
export function hasForeignOrganization(
  items: readonly AdminInvitation[] | undefined,
  organizationId: string,
): boolean {
  return (items ?? []).some((item) => item.organization?.id !== organizationId);
}
